module.exports = __webpack_public_path__ + "static/img/cup_pink.b7c4bad0.png";